<template>
    <div class="flex w-screen h-screen bg-slate-500">
        <div class="h-screen w-screen bg-gradient-to-br from-base-200 to-base-300">
            <!-- Header Section -->

            <!-- Main Content -->
            <div class="flex h-screen ">
                <!-- Enhanced Sidebar -->
                <aside class=" bg-base-100 shadow-xl flex h-screen">
                    <!-- Search and Filter Section -->
                    <!--
                <div class="p-4 lg:p-6 border-b border-base-200 space-y-4">
                    <div class="form-control">
                        <input 
                            type="text" 
                            placeholder="Buscar dispositivos..." 
                            class="input input-bordered w-full"
                            v-model="searchQuery"
                        />
                    </div>
                    <div class="flex gap-2">
                        <select class="select select-bordered flex-1" v-model="statusFilter">
                            <option value="">Todos los estados</option>
                            <option value="online">En línea</option>
                            <option value="offline">Desconectado</option>
                        </select>
                        <button class="btn btn-square btn-outline">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
                            </svg>
                        </button>
                    </div>
                </div>
                -->
                    <!-- Content Container -->
                    <div class="flex overflow-y-auto">
                        <!-- Device List -->
                        <div class="transition-all duration-300"
                            :class="showTelemetryPanel ? 'w-96 border-r border-base-300' : 'flex-1'">
                            <div v-if="loading" class="flex flex-col items-center justify-center py-12">
                                <span class="loading loading-spinner loading-lg text-primary"></span>
                                <span class="mt-4 text-base-content">Cargando dispositivos...</span>
                            </div>
                            <div v-else class="p-2 space-y-2">
                                <DeviceCard class="" v-for="device in filteredDevices" :key="device.device_sn"
                                    :device="device" :isSelected="selectedDevice?.device_sn === device.device_sn"
                                    @select="selectDevice" @centerMap="centerMapOnDevice" />
                            </div>
                        </div>
                    </div>
                </aside>

                <!-- Map Section -->
                <div class="flex-1 p-4 lg:p-6 w-auto h-full">
                    <div class="bg-base-100 rounded-xl shadow-lg h-full overflow-hidden">
                        
                        <!--
                    <div class="p-4 border-b border-base-200 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                        <h2 class="text-base lg:text-lg font-semibold text-base-content">Ubicaciones de Dispositivos</h2>
                        <div class="flex gap-2">
                            <button class="btn btn-sm btn-outline">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                                </svg>
                                <span class="hidden sm:inline">Lista</span>
                            </button>
                            <button class="btn btn-sm btn-primary">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7"></path>
                                </svg>
                                <span class="hidden sm:inline">Mapa</span>
                            </button>
                        </div>
                    </div>
                    -->
                        <div class="relative h-full w-full">
                            <div v-if="loading" class="absolute inset-0 flex items-center justify-center bg-base-200">
                                <span class="loading loading-spinner loading-lg text-primary"></span>
                            </div>
                            <div ref="mapRef" class="w-full h-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted, nextTick, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getDevices } from '@/v2/application/usecases/devicesCase';
import { useDevicesStore } from '@/v2/application/stores/devicesStore';
import { storeToRefs } from 'pinia';
import DeviceCard from './DeviceCard.vue';
import { loadGoogleMapsApi, MapManager } from './mapManager.js';

const router = useRouter();
const devicesStore = useDevicesStore();
const { devices } = storeToRefs(devicesStore);
const loading = ref(true);
const mapRef = ref(null);
let mapManager = null;

// New reactive variables for enhanced functionality
const searchQuery = ref('');
const statusFilter = ref('');
const selectedDevice = ref(null);



const filteredDevices = computed(() => {
    return devices.value.filter(device => {
        return device.domain === 3;
    });
});

// Method to handle device selection
const selectDevice = (device) => {
    selectedDevice.value = device;
};


// Method to center map on device
const centerMapOnDevice = (device) => {
    if (!mapManager) return;

    const telemetry = devicesStore.getDeviceTelemetry(device.device_sn);
    if (!telemetry) return;

    const lat = telemetry.latitude;
    const lng = telemetry.longitude;

    if (lat && lng && lat !== 0 && lng !== 0) {
        const map = mapManager.getMapInstance();
        if (map) {
            map.setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) });
            map.setZoom(15);
        }
    }
};


import { createClient, setupMqttClient } from '@/v2/application/usecases/mqttCase';

const mqttClient = ref(null);

const initMqtt = () => {
    mqttClient.value = createClient()
    setupMqttClient(mqttClient.value);
}
import { manageDevicesMarkers } from '@/v2/application/usecases/mapMarkerManager';
onMounted(async () => {
    await getDevices();
    loading.value = false;
    await nextTick();
    initMqtt();
    loadGoogleMapsApi({
        apiKey: 'AIzaSyA18csPg7BRihV1O9iU9qBjMKFtuRti5eY',
        callback: () => {
            mapManager = new MapManager(mapRef.value);
            mapManager.initMap({
                center: { lat: -34.6037, lng: -58.3816 },
                zoom: 10,
                onReady: (map) => {
                    // Ejemplo: agregar marcadores de dispositivos si tienen lat/lng
                    // devices.value.forEach(device => {
                    //   if (device.lat && device.lng) {
                    //     mapManager.addMarker({ lat: device.lat, lng: device.lng, title: device.device_name });
                    //   }
                    // });
                    manageDevicesMarkers(mapManager)
                }
            });
        }
    });
});
</script>

<style scoped>
/* DaisyUI y Tailwind se encargan del estilo, no es necesario CSS extra */
</style>